import { render, staticRenderFns } from "./merchantBackground.vue?vue&type=template&id=43c76e4f&scoped=true&"
import script from "./merchantBackground.vue?vue&type=script&lang=ts&"
export * from "./merchantBackground.vue?vue&type=script&lang=ts&"
import style0 from "./merchantBackground.vue?vue&type=style&index=0&id=43c76e4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c76e4f",
  null
  
)

export default component.exports